// This file is part of Coog. The COPYRIGHT file at the top level of
// this repository contains the full copyright notices and license terms.

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';

import cn from 'classnames';

import ConfirmationCommon from '../Confirmation';
import SelectCommon from '../Select';

import { CSS_UID } from './index.utils';

import './index.scss';

/**
 * Field component
 * @param props
 * @returns {XML}
 * @constructor
 */
const DuplicateCommon = ({
  label,
  validateLabel,
  cancelLabel,
  isLoadingValidate,
  disabled,
  selection,
  eventEmitter,
  placeholder,
  styleSelect,
}) => {
  const [btnState, setBtnState] = useState(false);
  const [localValue, setLocalValue] = useState();
  const [hasValidated, setHasValidated] = useState(false);
  const [canResetState, setCanResetState] = useState(false);

  if (hasValidated && isLoadingValidate) {
    setCanResetState(true);
    setHasValidated(false);
  } else if (canResetState && !isLoadingValidate) {
    setCanResetState(false);
    setBtnState(false);
    setLocalValue();
  }

  const clickMainButton = () => {
    setBtnState(true);
  };

  const clickCancel = () => {
    setLocalValue();
    setBtnState(false);
  };

  const clickValidate = () => {
    eventEmitter(localValue);
    setHasValidated(true);
  };

  return (
    <div className={cn(CSS_UID, { 'button-expanded': btnState })}>
      <ConfirmationCommon label={label} disabled={disabled} isBtnOpen={btnState} handlerMainButton={clickMainButton}>
        <>
          <SelectCommon
            field={{ name: 'duplicate', value: localValue }}
            placeholder={placeholder}
            selection={selection}
            disabled={isLoadingValidate}
            width={styleSelect.width}
            height={styleSelect.height}
            minWidthMenu={styleSelect.minWidthMenu}
            eventEmitter={val => setLocalValue(val)}
          />
          <button
            className={cn(`button button-primary`, { disabled: !localValue || isLoadingValidate })}
            id="validate--button"
            type="button"
            disabled={!localValue || isLoadingValidate}
            onClick={clickValidate}
          >
            {isLoadingValidate ? (
              <FontAwesomeIcon className="spinner-button-style" icon={faCircleNotch} spin size="lg" />
            ) : (
              validateLabel
            )}
          </button>
          <button
            className={cn(`button button-error`, { disabled: isLoadingValidate })}
            id="cancel--button"
            type="button"
            disabled={isLoadingValidate}
            onClick={clickCancel}
          >
            {cancelLabel}
          </button>
        </>
      </ConfirmationCommon>
    </div>
  );
};

DuplicateCommon.propTypes = {
  label: PropTypes.string.isRequired,
  validateLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  isLoadingValidate: PropTypes.bool,
  disabled: PropTypes.bool,
  selection: PropTypes.array, // eslint-disable-line react/forbid-prop-types
  eventEmitter: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  styleSelect: PropTypes.shape({
    width: PropTypes.string,
    minWidthMenu: PropTypes.string,
    height: PropTypes.string,
  }),
};

DuplicateCommon.defaultProps = {
  validateLabel: 'Valider',
  cancelLabel: 'Annuler',
  isLoadingValidate: false,
  disabled: false,
  selection: [],
  placeholder: undefined,
  styleSelect: {},
};

export default DuplicateCommon;
